// Modelli suggeriti nei campi "Modello AI" (impostazione globale in /settings e override per
// cooperativa in /org). L'elenco è solo un aiuto contro i refusi: i campi restano a testo libero,
// così un modello nuovo è utilizzabile subito senza toccare il codice.
export const AI_MODEL_SUGGESTIONS = [
	"gpt-5.6-luna",
	"gpt-5-nano",
	"gpt-5-mini",
	"gpt-5",
	"gpt-4.1-mini",
	"gpt-4.1",
	"gpt-4o-mini",
	"gpt-4o"
];

export const AI_MODEL_OPTIONS = AI_MODEL_SUGGESTIONS.map(value => ({value, label: value}));

export function filterAiModelOption(input, option)
{
	const needle = String(input || "").trim().toLowerCase();
	if (!needle)
		return true;

	return String(option?.value || "").toLowerCase().includes(needle);
}
